<template>
  <div class="infoCon">
    <LoadingSpan v-if='loading' fix>加载中...</LoadingSpan>
    <div class="container">
      <lk-card>
        <h3>购药信息</h3>
        <PatientInfos
          :salePrescription='salePrescription'
        />
        <PharmaceuticalCareButton :showPharmaceuticalCareButton="showPharmaceuticalCareButton"></PharmaceuticalCareButton>
        <lk-table
          :columns='columns1'
          border
          :data='historyPurchaseDetails'
        ></lk-table>
      </lk-card>
    </div>
    <div class="followUpContent">
      <div class="contentLeft">
        <lk-card>
          <lk-tabs type="card" @on-click='handlerTabs'>
            <lk-tab-pane label='本次随访' :name='tabsNames[1]'>
              <div class="tableCon">
                <lk-table
                class='interviewee'
                border
                :columns='columns4'
                :data='[interviewTask]'
              ></lk-table>
              <lk-table
                :columns='columns2'
                border
                :data='interviewTable'
              ></lk-table>
              <div v-for="(item, index) in lkFormData" :key='index'>
                <div v-for="(subItem, idx) in item.athenaTemplateInfos" :key='idx'>
                  <Uiform
                    :layoutData="subItem.content"
                    :paramsData="subItem.contentResultJson"
                    :actions='subItem.onChangeData'
                    :formConfig="formConfig">
                  </Uiform>
                </div>
              </div>
              <div style="marginBottom: 20px">
                <Interviewee
                  v-model='interview'
                  ref="Interviewee"
                  :taskIds='taskIds'
                  :isEdit="isEdit"
                />
              </div>
            </div>
            </lk-tab-pane>
            <lk-tab-pane label='历史随访纪录' :name='tabsNames[2]'>
              <div id='historicalRecords'>
                <div v-if="interviewTasks.length" class='historicalRecordsCon'>
                  <lk-card calss='records'>
                    <div>
                      <h4 style="paddingBottom: 6px">随访记录</h4>
                      <lk-timeline >
                        <div
                          :class="historyTimeLineId==item.id?'recordsTimeline':'timeline'"
                          v-for="(item, index) in interviewTasks" :key="index"
                          @click='handlerTimeLine(item.id)'
                        >
                          <lk-timeline-item
                            :color="item.results == 1 ? 'green' : 'red'"
                          >
                          {{`${item.results == 1 ? '随访成功' : '随访失败'}
                            ${item.followUpTime}`}}
                          </lk-timeline-item>
                        </div>
                      </lk-timeline>
                    </div>
                  </lk-card>
                  <lk-card class='historicalTable'>
                    <div class="tableCon">
                      <lk-table
                        class='interviewee'
                        :columns='columns4'
                        border
                        :data='interviewTasksTableData'
                      ></lk-table>
                      <lk-table
                        :columns='historyColumns'
                        border
                        :data='historyInterview'
                      ></lk-table>
                      <div v-for="(item, index) in historyLkFormData" :key='index'>
                        <div v-for="(subItem, idx) in item.athenaTemplateInfos" :key='idx'>
                          <Uiform
                            :layoutData="subItem.content"
                            :paramsData="subItem.contentResultJson"
                            :actions='subItem.onChangeData'
                            :formConfig="historyFormConfig">
                          </Uiform>
                        </div>
                      </div>
                    </div>
                  </lk-card>
                </div>
                <div v-else>
                  <span>暂无随访记录</span>
                </div>
              </div>
            </lk-tab-pane>
          </lk-tabs>
        </lk-card>
      </div>
      <div class="contentRight">
        <div id='rightTable' >
          <div class='tableTitle'>患者用药指导及注意事项</div>
          <div v-if='lkFormData.length'>
            <table
              v-for='(group, index) in lkFormData'
              :key='index'
            >
              <colgroup>
                <col width='60px'>
                <col width='calc(100% - 60px)'>
              </colgroup>
              <thead>
                <tr>
                  <th>药品信息</th>
                  <th>{{`${group.goodsName}(${group.specifications || ''})`}}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>用药注意事项</td>
                  <td v-html="group.goodsUsageAttention.replace(/(\r\n|\n|\r)/gm, '<br/>')"></td>
                </tr>
                <tr>
                  <td>用药护理方案</td>
                  <td v-html="group.goodsUsageNursing.replace(/(\r\n|\n|\r)/gm, '<br/>')"></td>
                </tr>
                <tr>
                  <td>用药金融方案</td>
                  <td v-html="group.goodsUsageFinance.replace(/(\r\n|\n|\r)/gm, '<br/>')"></td>
                </tr>
                <template v-for='quesItem in group.goodsBaseFaqVoList'>
                  <tr>
                    <td>问题标题</td>
                    <td>{{quesItem.questionType}}</td>
                  </tr>
                  <tr>
                    <td>药师回复</td>
                    <td v-html="quesItem.answer.replace(/(\r\n|\n|\r)/gm, '<br/>')"></td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
            <div v-else>
            <span>暂无相关信息</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bottomFix" v-if="this.isEdit">
      <div class="btns">
        <lk-button type='primary' ref="end" @click="validate">提交</lk-button>
      </div>
    </div>
  </div>
</template>
<script>
import Uiform from '@linkdoc/ui-lkform';
import PatientInfos from '../../components/sale/PatientInfos.vue';
import Interviewee from '../../components/sale/Interviewee.vue';
import sale from '../../services/sale';
import utils from '../../libs/utils';
import LoadingSpan from '../../components/LoadingSpan.vue';
import PharmaceuticalCareButton from '../../components/sale/PharmaceuticalCareButton.vue';

export default {
  name: 'guidanceAndAppointment',
  components: {
    PatientInfos,
    Interviewee,
    Uiform,
    LoadingSpan,
    PharmaceuticalCareButton,
  },

  computed: {
    phoneStatusList() {
      return this.interviewTable.map(item => item.phoneStatus);
    },
  },
  watch: {
    interviewTable: {
      handler() {
        // 未接通未false
        this.isNoUse = this.phoneStatusList.indexOf(1) !== -1;
        this.formConfig.formDisabled = !this.isNoUse;
      },
      deep: true,
    },
  },
  data() {
    return {
      isEdit: false,
      loading: false,
      historyTimeLineId: 0, // 历史随访记录点击颜色控制
      showPharmaceuticalCareButton: true,
      relationshipList: {
        1: '患者本人',
        2: '患者配偶',
        3: '患者子女',
        4: '患者家属',
        5: '其他',
      },
      interviewStatusList: [
        {
          code: 1,
          txt: '代随访',
        },
        {
          code: 2,
          txt: '随访中',
        },
        {
          code: 3,
          txt: '本次失访',
        },
      ],
      tabsNames: {
        1: 'currentFlowUp',
        2: 'historicalFlowUp',
      },
      goodsBase: [], // 患者用药指导
      lkFormData: [],
      historyLkFormData: [], // 历史随访记录lkformdata
      historyFormConfig: {
        needGroup: true,
        formDisabled: true,
        submitFlag: false,
        disabledShowForm: false,
        showSubmitBtn: false,
      },
      formConfig: {
        needGroup: true,
        formDisabled: false,
        submitFlag: false,
        disabledShowForm: false,
        showSubmitBtn: false,
        uploadUrl: '/v1/erp-business-web/bluewhale/getUpload',
        getImgUrl: '/v1/erp-business-web/bluewhale/getSign',
      },
      historyInterviewModifiedTime: 0,
      taskIds: [], // 已经预约的时间
      isNoUse: true,
      // phoneStatusList: [], // 接通情况
      interviewTask: {
        isInterviewToo: '',
      }, // 随访任务
      interviewTable: [], // 要合并的任务
      historyPurchaseDetails: [], // top历史购药信息
      interviewTasks: [], // 底部历史任务
      interviewTasksTableData: [], // 历史随访人
      salePrescription: {}, // 患者信息
      historyInterview: [], // 历史随访记录table
      recoredList: ['首次', '二次', '三次'],
      taskInquiry: [
        {
          question: '',
          answer: '',
        },
      ], // 用药咨询
      interview: {},
      info: {}, // 随访记录
      checkStatus: null,
      contactRelationList: {
        1: '本人',
        2: '父母',
        3: '子女',
        4: '朋友',
        5: '其他',
      },
      columns1: [
        {
          title: '购药日期',
          key: 'purchaseDate',
          minWidth: 116,
          render: (h, params) => h('span', utils.exchangeTime(params.row.purchaseDate)),
        },
        {
          title: '订单编号',
          key: 'orderNo',
          minWidth: 116,
        },
        {
          title: '商品名称',
          key: 'goodsName',
          minWidth: 116,
        },
        {
          title: '通用名',
          key: 'approveName',
          minWidth: 116,
        },
        {
          title: '规格',
          key: 'spec',
          minWidth: 116,
        },
        {
          title: '数量',
          key: 'num',
          minWidth: 116,
        },
        {
          title: '处方医院',
          key: 'hospital',
          minWidth: 116,
        },
        {
          title: '处方医生',
          key: 'doctor',
          minWidth: 116,
        },
        {
          title: '诊断',
          key: 'diseaseName',
          minWidth: 116,
        },
        {
          title: '诊断说明',
          key: 'diseaseRemark',
          minWidth: 116,
        },
        {
          title: '用法',
          key: 'goodsUsage',
          minWidth: 116,
        },
        {
          title: '频次',
          key: 'frequencyName',
          minWidth: 116,
        },
        {
          title: '每次用量',
          key: 'goodsDosage',
          minWidth: 116,
        },
        {
          title: '有效期',
          key: 'expiryDate',
          minWidth: 116,
          render: (h, params) => h('span', utils.exchangeTime(params.row.expiryDate)),
        },
        {
          title: '储存条件',
          key: 'storageCondition',
          minWidth: 116,
        },
        {
          title: '生产厂家',
          key: 'producer',
          minWidth: 116,
        },
      ],
      columns2: [
        {
          title: '任务编号',
          width: 60,
          key: 'taskId',
        },
        {
          title: '呼叫编号',
          width: 96,
          key: 'phoneCode',
        },
        {
          title: '预约随访时间',
          width: 130,
          key: 'time',
        },
        {
          title: '呼叫情况',
          minWidth: 90,
          render: (h, params) => h('lk-radio-group', {
            props: {
              value: params.row.checkStatus,
            },
            on: {
              'on-change': (status) => {
                if (status === 'false') {
                  this.$set(this.interviewTable[params.index], 'checkStatus', 'false');
                  this.$set(this.interviewTable[params.index], 'phoneStatus', 2);
                } else {
                  this.$set(this.interviewTable[params.index], 'checkStatus', 'true');
                  this.$set(this.interviewTable[params.index], 'phoneStatus', 1);
                }
              },
            },
          }, [
            h('lk-radio', {
              props: {
                label: 'true',
                disabled: !this.isEdit,
              },
            }, '接通'),
            h('lk-radio', {
              props: {
                label: 'false',
                disabled: !this.isEdit,
              },
            }, '未接通'),
          ]),
        },
        {
          title: '备注',
          minWidth: 190,
          render: (h, params) => h('lk-input', {
            on: {
              'on-blur': (e) => {
                this.$set(this.interviewTable[params.index], 'remark', e.target.value);
              },
            },
            props: {
              maxlength: 200,
              value: params.row.remark || '',
              disabled: !this.isEdit,
            },
          }),
        },
        {
          title: '提交时间',
          minWidth: 130,
          key: '',
          render: (h, params) => h('span', utils.formatTime(params.row.submittime)),
        },
      ],
      columns4: [
        {
          title: '被访人姓名',
          key: 'intervieweeName',
          width: 100,
        },
        {
          title: '被访人电话',
          key: 'phone',
          width: 120,
        },
        {
          title: '与用药人关系',
          key: 'relationship',
          width: 110,
          render: (h, params) => h('span', params.row.relationship ? this.relationshipList[params.row.relationship] : ''),
        },
      ],
      historyColumns: [
        {
          title: '任务编号',
          width: 60,
          key: 'taskId',
        },
        {
          title: '呼叫编号',
          width: 80,
          key: 'code',
        },
        {
          title: '预约随访时间',
          width: 110,
          key: 'viewTime',
          render: (h, params) => h('span', utils.formatTime(params.row.viewTime)),
        },
        {
          title: '呼叫情况',
          minWidth: 60,
          render: (h, params) => h('span', params.row.result === 1 ? '接通' : '未接通'),
        },
        {
          title: '备注',
          minWidth: 100,
          key: 'remarks',
        },
        {
          title: '提交时间',
          minWidth: 110,
          key: '',
          render: (h, params) => h('span', utils.formatTime(this.historyInterviewModifiedTime)),
        },
      ],
    };
  },
  methods: {
    // tabs点击事件
    handlerTabs(name) {
      if (name === this.tabsNames[2]) {
        if (this.interviewTasks.length) {
          this.historyTimeLineId = this.interviewTasks[0].id;
          this.handlerTimeLine(this.interviewTasks[0].id); // 默认第一条历史记录
        }
      }
    },
    // 时间线点击事件
    handlerTimeLine(taskId) {
      this.historyTimeLineId = taskId;
      const { patientId } = this.$route.params;
      const params = {
        taskId,
        patientId,
      };
      sale.getHistoyPharmaceuticalDetail(params).then((res) => {
        if (res.data.status === 200) {
          this.historyLkFormData = [];
          this.historyInterview = res.data.data.interviewCalls;
          this.historyInterviewModifiedTime = res.data.data.modifiedTime;
          this.historyLkFormData = this.setFormData(res.data.data.goodsBases, false);
          this.interviewTasksTableData = [];
          this.interviewTasksTableData.push(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },

    // 获取元素绝对高度
    getElementTop(element) {
      let actualTop = element.offsetTop;
      let current = element.offsetParent;
      while (current !== null) {
        actualTop += current.offsetTop;
        current = current.offsetParent;
      }
      return actualTop;
    },

    validate() {
      // 未接通可以提交
      this.handlerRmeark();
      // 信息没填
      if (this.phoneStatusList.indexOf(1) === -1 && this.phoneStatusList.indexOf(2) === -1) {
        this.$Message.error('请完善呼叫情况');
        return;
      }
      if (this.isNoUse) {
        const errorDom = document.getElementById('errorItem');
        if (errorDom) {
          const errorDomTop = this.getElementTop(errorDom) - 50;
          document.documentElement.scrollTop = errorDomTop;
          document.body.scrollTop = errorDomTop;
          const errorTip = errorDom.getAttribute('data-error-tip');

          this.$Message.error(errorTip, 2);
          return;
        }
        this.$refs.Interviewee.validaForm().then((valid) => {
          if (valid) {
            const {
              result1,
              result2,
              result3,
            } = this.info;
            if (!result1 && !result2 && !result3) {
              this.$Message.error('请填写随访结果');
              return;
            }
            this.saveInterviewInfo();
          }
        });
      } else {
        this.saveInterviewInfo();
      }
    },
    saveInterviewInfo() {
      const { taskId, patientId } = this.$route.params;
      const saveTemplatesList = [];
      this.lkFormData.forEach((item) => {
        item.athenaTemplateInfos.forEach((subItem) => {
          const obj = {
            interviewId: taskId,
            goodsBaseId: item.id,
            templateId: subItem.id,
            templateName: subItem.name,
            templateContent: JSON.stringify(subItem.content),
            templateResult: this.isNoUse ? JSON.stringify(subItem.contentResultJson) : '',
          };
          saveTemplatesList.push(obj);
        });
      });
      const params = {
        taskId,
        patientId,
        ...this.interview,
        ...this.info,
        taskInquiry: this.taskInquiry,
        saveTemplatesList,
      };
      sale.saveInterviewInfo(params).then((res) => {
        if (res.data.status === 200) {
          this.$router.go(-1);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    clearParams() {
      this.info = {};
      this.$set(this.interview, 'isInterviewToo', '');
      this.$set(this.interview, 'Interviewee', '');
      this.$set(this.interview, 'isImport', '');
      this.$set(this.interview, 'time1', '');
      this.$set(this.interview, 'time2', '');
      this.$set(this.interview, 'time3', '');
      this.$set(this.interview, 'taskIdToMerge', '');
      this.$set(this.interview, 'reasonStop', '');
    },
    handlerRmeark() {
      this.interviewTable.forEach((item) => {
        switch (item.name) {
          case 'time1':
            this.info.remark1 = item.remark;
            this.info.result1 = item.phoneStatus || '';

            break;
          case 'time2':
            this.info.remark2 = item.remark;
            this.info.result2 = item.phoneStatus || '';
            break;
          case 'time3':
            this.info.remark3 = item.remark;
            this.info.result3 = item.phoneStatus || '';
            break;
          default:
            break;
        }
      });
    },
    handleTime(obj) {
      const { time1, time2, time3 } = obj;
      const timeObj = { time1, time2, time3 };
      this.interviewTable = [];
      let index = 1;
      for (const key in timeObj) {
        if (obj[key] != undefined) {
          const idx = key.substring(key.length - 1);
          const result = obj[`result${idx}`];
          const remark = obj[`remark${idx}`];
          const submittime = obj[`submitTime${idx}`];
          this.interviewTable.push({
            time: utils.formatTime(obj[key]),
            name: key,
            remark,
            taskId: this.interviewTask.id,
            modifiedTime: this.interviewTask.modifiedTime,
            phoneCode: `${this.interviewTask.id}-${index++}`,
            // eslint-disable-next-line no-nested-ternary
            checkStatus: result === 1 ? 'true' : result === 2 ? 'false' : '',
            submittime,
          });
        }
      }
    },
    getData() {
      this.loading = true;
      const { taskId, patientId } = this.$route.params;
      const params = {
        taskId,
        patientId,
      };
      sale.getPharmaceuticalDetail(params).then((res) => {
        if (res.data.status === 200) {
          const { data } = res.data;
          this.historyPurchaseDetails = data.historyPurchaseDetails;
          this.interviewTask = data.interviewTask;
          const { intervieweeName, phone, relationship } = data.interviewTask;
          // interviewStatus  1代随访， 2随访中，3失访，4完成，5永久失访
          // 待办事项无法判断是不是本药师，后端只能跳转编辑页，所以isEdit需要重新判断
          if (this.$route.name === 'patientFollowUpEdit') {
            this.isEdit = data.salePrescription.pharmaceuticalCareOnlyCheck === 2;
          }
          const statusList = this.interviewStatusList.map(item => item.code);
          if (data.nextInterviewTask) {
            this.info = data.interviewTask;
            this.interview = data.nextInterviewTask;
            this.taskInquiry = data.interviewTask.taskInquiry;
          } else {
            this.interview = { intervieweeName, phone, relationship };
          }
          this.taskIds = data.taskIds;
          data.interviewTasks.forEach((item) => {
            const result = item;
            result.followUpTime = utils.exchangeTimeToSecond(result.followUpTime);
            this.interviewTasks.push(result);
          });
          this.salePrescription = data.salePrescription;

          this.lkFormData = this.setFormData(data.interviewTask.goodsBases, statusList.includes(data.interviewTask.interviewStatus));
          if (!this.isEdit) {
            this.formConfig.formDisabled = true;
          }
          this.handleTime(data.interviewTask);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    /**
     * @list lkform数据
     * @type  是否需要接收lkform填写的数据
     */
    setFormData(list, type) {
      list.forEach((item) => {
        item.athenaTemplateInfos.length && item.athenaTemplateInfos.forEach((subItem) => {
          if (subItem.id && !subItem.content) {
            this.$Message.warning('模版配置错误，请联系管理员');
          }
          subItem.content = subItem.content ? JSON.parse(subItem.content) : [];
          subItem.onChangeData = subItem.onChange ? JSON.parse(subItem.onChange) : {};
          if (type) {
            this.$set(subItem, 'contentResultJson', {});
          }
        });
      });
      this.loading = false;
      return list;
    },
  },
  created() {
    document.querySelector('body').setAttribute('style', 'font-size: 12px;');
  },
  mounted() {
    this.isEdit = this.$route.name === 'patientFollowUpEdit';
    this.getData();
  },
};
</script>
<style lang="less" scoped>
.infoCon {
  min-height: calc(~'100vh - 60px');// 100vh;
  .followUpContent {
    display: flex;
    margin-top: 4px;
    position: relative;
    .contentLeft {
      width: 70%;
      height: auto;
      #historicalRecords {
        display: flex;
        .historicalRecordsCon {
          display: flex;
        }
        .records {
          width: 20%;
        }
        .recordsTimeline {
          cursor: pointer;
          color: #2d8cf0;
        }
        .timeline {
          cursor: pointer;
        }
        .historicalTable {
          width: 80%
        }
      }
      .interviewee {
        width: 332px;
        margin-bottom: 10px;
      }
    }
    .contentRight {
      background:#fff;
      width: 30%;
      overflow-y: scroll;
      padding-left: 6px;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      display: inline-block;
      #rightTable {
        padding-bottom: 30px;
        .tableTitle {
          font-size: 14px;
          font-weight: 500;
        }
        table {
          font-size: 13px;
          border: 1px solid #dcdee2;
          tr{
            border-bottom: 1px solid #e8eaec;
          }
          margin-bottom: 6px;
        }
        thead {
          text-align: left;
          tr {
            th {
              height: 40px;
              background-color: #f8f8f9;
              border-right: 1px solid #e8eaec;
            }
            th:last-child {
              padding-left: 5px;
            }
          }
        }
        tbody {
          tr {
            height: 30px;
            td {
              border-right: 1px solid #e8eaec;
              word-break: break-all;
            }
            td:last-child {
              padding-left: 5px;
            }
          }
        }
      }
      .timelineCon {
        width: 100%;
        height: 50%;
        padding: 20px 0 0 40px;
      }
    }
  }
  /deep/ .ivu-radio-wrapper {
    margin-right: 20px !important;
  }
  /deep/ .ivu-divider-horizontal {
    margin: 0;
  }
  .tableCon {
    /deep/ .ivu-radio-wrapper {
      margin-right: 30px !important;
    }
    /deep/ .ivu-radio-inner {
      border-radius: 0%;
    }
  }
  .bottomFix{
    background: #fff;
    position: fixed;
    padding: 0 38px;
    bottom:0;
    width: 100%;
    border-top: 1px solid #eee;
    height: 60px;
    z-index: 10;
    box-shadow: 0 0 8px #eee;
    .btns{
      position: fixed;
      height: 60px;
      bottom:0;
      right: 40px;
      line-height: 60px
    }
  }
  .tableCon {
    max-height: 1000px;
    overflow-y: scroll;
    margin-bottom: 30px;
  }
}
</style>
